export default "__VITE_ASSET__BmaK65hR__"